import * as React from 'react'
import { SVGProps } from 'react'

const SvgRingingYellowStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.569 0s-.882 8.331 4.588 13.169c5.47 4.839 13.19 4.609 13.19 4.609s-8.786-.382-13.099 4.878c-4.313 5.258-4.687 13.111-4.687 13.111s-.876-8.917-4.832-12.728C8.397 18.861 0 17.883 0 17.883s8.814-.112 13.128-4.53C17.441 8.936 17.569 0 17.569 0Z"
      fill="#FEDF99"
    />
  </svg>
)

export default SvgRingingYellowStar
